// components/ScreenShots/ScreenShots.jsx


import React, { useState, useEffect, useRef } from 'react';
import './css/ScreenShots.css';

// Импортируем скриншоты (замени пути на свои реальные файлы)
import agentsImg from '../../img/screenshots/agentsImg.png';
import scanningImg from '../../img/screenshots/scanningImg.png';
import usersImg from '../../img/screenshots/usersImg.png';
import tagsImg from '../../img/screenshots/tagsImg.png';
import diskImg from '../../img/screenshots/diskImg.png';
import journalImg from '../../img/screenshots/journalImg.png';
import webImg from '../../img/screenshots/webImg.png';
import mailImg from '../../img/screenshots/mailImg.png';
  const ScreenShotsData = [
    {
      id: 1,
      name: "Агенты",
      features: [
        "Отслеживание состояния", 
        "Просмотр файлов на устройстве",
        "Маркировка файлов",
        "Контроль активности",
        "Контроль дисков",
      ],
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 297 297"><path d="m102.651 253.945-.068-.139 16.5-12.92-30.623-55.712-.086-.157C51.307 199.906 26.287 233.051 26.287 297h97.472l-21.176-43 .068-.055zM178.157 240.752l16.426 13.055-.068.139.068.055-21.174 43h97.304c0-63.95-25.012-97.084-62.067-111.976l-.086.157-30.403 55.57zM148.5 206.007c-4.319 0-8.57-.293-12.74-.85l6.817 12.327-5.42 79.516h22.686l-5.42-79.516 6.817-12.327c-4.17.557-8.421.85-12.74.85zM228.184 110.561c-5.781.802-15.017 1.926-26.017 2.943v11.993c0 11.737-9.762 21.253-21.5 21.253s-21.5-9.516-21.5-21.253v-9.616c-3 .074-7.172.119-11 .119-3.828 0-8-.045-11-.119v9.616c0 11.737-9.762 21.253-21.5 21.253s-21.5-9.516-21.5-21.253v-11.993a570.631 570.631 0 0 1-25.657-2.937c-.009-.001.065-.007.056-.007.166 43.903 35.993 79.44 79.934 79.44h.026c43.93 0 79.492-35.545 79.658-79.439zM70.294 94.61C82.852 96.355 113.296 100 148.5 100s65.648-3.645 78.206-5.39c-.008-.038-.014-.078-.021-.117 5.856-.862 11.137-1.82 15.742-2.858C255.39 88.713 263 85.157 263 81.322c0-4.506-10.499-8.627-27.855-11.787-2.73-.497-5.635-.97-8.69-1.418a76.113 76.113 0 0 0-2.157-16.293C216.959 21.977 192.012 0 161.935 0h-26.869c-30.677 0-56.743 22.863-63.719 53.621a74.102 74.102 0 0 0-1.804 14.644c-2.691.403-5.257.827-7.688 1.271C44.499 72.695 34 76.816 34 81.322c0 3.835 7.61 7.391 20.573 10.313 4.605 1.038 9.886 1.996 15.742 2.858-.007.039-.013.079-.021.117z" fill="#000000" opacity="1" data-original="#000000"></path></svg>,
      screenshot: agentsImg
    },
    {
      id: 2,
      name: "Сканирование",
      features: [
        "Настройка сканирования",
        "Отслеживание состояний",
        "Управление персональными данными",
        "Перемещение данных",
        "Автоматическое обнаружение"
      ],
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32"><path d="M23.62 12.94h4.37l-5.25-4.97V12c0 .52.4.94.88.94z" fill="#000000" opacity="1" data-original="#000000"></path><path d="M23.62 14.94c-1.59 0-2.88-1.32-2.88-2.94V7.41H19.7c.02.22.03.45.03.67 0 2.05-.75 4.1-2.27 5.67-.54.56-1.14 1.02-1.79 1.39h3.12c.55 0 1 .44 1 1 0 .55-.45 1-1 1h-4.02c-.55 0-1-.45-1-1 0-.09.01-.17.04-.25-.63.17-1.3.26-1.97.26-.99 0-1.96-.18-2.86-.55v11.46c0 1.62 1.29 2.94 2.87 2.94h13.87c1.58 0 2.87-1.32 2.87-2.94V14.94zm-.82 10.5h-8.03c-.55 0-1-.45-1-1s.45-1 1-1h8.03c.55 0 1 .45 1 1s-.45 1-1 1zm0-4.15h-8.03c-.55 0-1-.45-1-1s.45-1 1-1h8.03c.55 0 1 .45 1 1s-.45 1-1 1z" fill="#000000" opacity="1" data-original="#000000"></path><path d="M11.84 14.15c1.58 0 3.07-.64 4.19-1.79 2.28-2.36 2.28-6.21 0-8.57C14.91 2.64 13.42 2 11.84 2c-1.59 0-3.07.64-4.19 1.79-2.05 2.12-2.26 5.449-.61 7.809l-3.347 3.46a1 1 0 0 0 1.437 1.39l3.309-3.42.001.001a5.68 5.68 0 0 0 3.4 1.12z" fill="#000000" opacity="1" data-original="#000000"></path></svg>,
      screenshot: scanningImg
    },
    {
      id: 3,
      name: "Пользователи",
      features: [
        "Управление ролями",
        "Добавление сотрудников",
        "Выдача доступов", 
        "Контроль привилегий",

      ],
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 32 32"><path d="M11.655 12.245c.998 2.334 4.031 3.49 6.32 2.361 3.058-1.244 3.756-5.735 1.276-7.848-3.781-3.525-9.746.756-7.596 5.487zM21.206 17.006c-.958-.609-2.125-.936-3.31-.948-.14-.004-4.144-.012-4.141.00-3.28.15-5.943 2.922-5.942 6.27.056.555-.09 2.24.087 2.758a3.395 3.395 0 0 0 3.3 2.613h9.6c1.884.008 3.406-1.565 3.387-3.387v-1.984a6.287 6.287 0 0 0-2.98-5.342z" fill="#000000" opacity="1" data-original="#000000"></path><path d="M4.242 25.106h2.187c-.125-.506-.047-2.355-.068-2.903a7.773 7.773 0 0 1 5.526-7.277c-.287-.228-.539-.532-.774-.803a4.855 4.855 0 0 0-.648-.04H6.932A5.94 5.94 0 0 0 1 20.017v1.849a3.242 3.242 0 0 0 3.242 3.241zM8.703 13.358c.61 0 1.18-.116 1.713-.339a6.051 6.051 0 0 1-.639-2.98 6.21 6.21 0 0 1 2.11-4.452C9.168 2.776 4.07 4.857 4.155 8.82c0 2.496 2.042 4.538 4.548 4.538zM25.068 14.084h-3.533c-.695-.148-.954.462-1.422.842a7.637 7.637 0 0 1 3.358 2.061 7.72 7.72 0 0 1 2.168 5.216c-.02.555.055 2.38-.068 2.903h2.187A3.242 3.242 0 0 0 31 21.865v-1.849a5.94 5.94 0 0 0-5.932-5.932zM21.836 8.094a6.155 6.155 0 0 1-.252 4.926 4.397 4.397 0 0 0 1.713.338c6.01-.196 6.009-8.889 0-9.077a4.549 4.549 0 0 0-3.184 1.306 6.137 6.137 0 0 1 1.723 2.507z" fill="#000000" opacity="1" data-original="#000000"></path></svg>,
      screenshot: usersImg
    },
    {
      id: 4,
      name: "Метки",
      features: [
        "Отслеживание файлов",
        "Контроль версий",
        "Предотвращение утечек",
        "Мониторинг доступов",
        "Классификация данных"
      ],
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 16 16"><g><path d="M13.476 4.519a3.5 3.5 0 0 0-3.5-3.5h-4a3.5 3.5 0 0 0-3.5 3.5v9.009a1.499 1.499 0 0 0 2.396 1.203l2.818-2.098a.501.501 0 0 1 .599 0l2.788 2.088a1.498 1.498 0 0 0 2.399-1.2z" fill="#000000" opacity="1" data-original="#000000" class=""></path></g></svg>,
      screenshot: tagsImg
    },
    {
      id: 5,
      name: "Диск",
      features: [
        "Локальное хранилище",
        "Централизованное хранение",
        "Управление файлами",
        "Восстановление данных",
        "Резервное копирование"
      ],
      icon: <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill="#000000" d="M21.795 12.645a3.77 3.77 0 0 0-2.36-0.935 4 4 0 0 0-3.435-4.67 4 4 0 0 0-3.375 1.185 4.5 4.5 0 0 0-8.625 1.645 1.355 1.355 0 0 0 0 0.145 4.055 4.055 0 0 0-3 4.05v0.05a4.58 4.58 0 0 0 4.63 4.45H20a3 3 0 0 0 3-3 3.79 3.79 0 0 0-1.205-2.855z"></path></svg>,
      screenshot: diskImg
    },
    {
      id: 6,
      name: "Журнал событий",
      features: [
        "Отслеживание инцидентов",
        "Мониторинг действий",
        "Анализ событий"
      ],
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 512 512"><path d="M440.08 341.31c-1.66-2-3.29-4-4.89-5.93-22-26.61-35.31-42.67-35.31-118 0-39-9.33-71-27.72-95-13.56-17.73-31.89-31.18-56.05-41.12a3 3 0 0 1-.82-.67C306.6 51.49 282.82 32 256 32s-50.59 19.49-59.28 48.56a3.13 3.13 0 0 1-.81.65c-56.38 23.21-83.78 67.74-83.78 136.14 0 75.36-13.29 91.42-35.31 118-1.6 1.93-3.23 3.89-4.89 5.93a35.16 35.16 0 0 0-4.65 37.62c6.17 13 19.32 21.07 34.33 21.07H410.5c14.94 0 28-8.06 34.19-21a35.17 35.17 0 0 0-4.61-37.66zM256 480a80.06 80.06 0 0 0 70.44-42.13 4 4 0 0 0-3.54-5.87H189.12a4 4 0 0 0-3.55 5.87A80.06 80.06 0 0 0 256 480z" fill="#ffffff" opacity="1" data-original="#000000"></path></svg>,
      screenshot: journalImg
    },
    {
      id: 7,
      name: "Веб-трафик",
      features: [
        "Блокировка сайтов",
        "Контроль посещенных страниц",
        "Отслеживание истории"
      ],
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g><g fill="#000"><path fill-rule="evenodd" d="M12 2C6.477 2 2 6.477 2 12s4.477 10 10 10c.428 0 .85-.027 1.264-.08a7.005 7.005 0 0 1-3.164-4.733c-.357-1.163-.603-2.598-.677-4.187h1.25a7.018 7.018 0 0 1 1.428-2H9.423c.092-1.979.45-3.72.96-4.993.298-.744.627-1.28.942-1.613.313-.33.542-.394.675-.394s.362.064.675.394c.315.333.644.869.942 1.613.374.936.667 2.123.833 3.472a6.96 6.96 0 0 1 1.958-.454c-.188-1.413-.508-2.696-.934-3.76a10.106 10.106 0 0 0-.259-.593A8.024 8.024 0 0 1 19.601 9.5c.89.357 1.69.89 2.355 1.558C21.481 5.977 17.205 2 12 2zm-7.938 9H7.42c.093-2.192.488-4.193 1.105-5.735.081-.204.167-.401.259-.593A8.008 8.008 0 0 0 4.061 11zm4.723 8.328a10.08 10.08 0 0 1-.26-.593C7.91 17.193 7.515 15.192 7.422 13h-3.36a8.008 8.008 0 0 0 4.724 6.328z" clip-rule="evenodd" fill="#ffffff" opacity="1" data-original="#000000" class=""></path><path d="M17.188 10.603c.198-.248.614-.595 1.216-.491.426.073.745.33.942.521.217.21.415.47.59.734.353.532.693 1.205.986 1.883.296.683.559 1.402.75 2.04.18.605.328 1.24.328 1.71a5 5 0 1 1-7.809-4.137 1.34 1.34 0 0 1 .873-.238c.33.028.578.176.738.304.207.164.376.389.49.555.052-.206.104-.44.159-.697l.027-.125c.094-.439.203-.946.34-1.34.072-.21.185-.486.37-.719z" fill="#ffffff" opacity="1" data-original="#000000" class=""></path></g></g></svg>,
      screenshot: webImg
    },
    {
      id: 8,
      name: "Почта",
      features: [
        "Отслеживание писем",
        "Контроль вложений и содержимого"
      ],
      icon: <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"><g><path fill="#ffffff" d="M22 8.608v8.142a3.25 3.25 0 0 1-3.066 3.245L18.75 20H5.25a3.25 3.25 0 0 1-3.245-3.066L2 16.75V8.608l9.652 5.056a.75.75 0 0 0 .696 0zM5.25 4h13.5a3.25 3.25 0 0 1 3.234 2.924L12 12.154l-9.984-5.23a3.25 3.25 0 0 1 3.048-2.919L5.25 4h13.5z" opacity="1" data-original="#000000" class=""></path></g></svg>,
      screenshot: mailImg
    },
  ];
const ScreenShots = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [fading, setFading] = useState(false);
  const [featuresVisible, setFeaturesVisible] = useState(false);
  const [containerHeight, setContainerHeight] = useState(100);
  const gridRef = useRef(null);
// Внутри компонента ScreenShots, после useState
useEffect(() => {
  // Предзагружаем текущий и следующий
  const current = ScreenShotsData[currentIndex].screenshot;
  const next = ScreenShotsData[(currentIndex + 1) % ScreenShotsData.length].screenshot;

  const preloadImage = (src) => {
    const img = new Image();
    img.src = src;
  };

  preloadImage(current);
  preloadImage(next);
}, [currentIndex]);


  // Эффект для обновления высоты контейнера
  useEffect(() => {
    const updateHeight = () => {
      if (gridRef.current) {
        const height = gridRef.current.scrollHeight;
        setContainerHeight(height);
      }
    };

    if (featuresVisible) {
      // Ждем немного, чтобы анимация появления фич завершилась и высота была правильной
      setTimeout(updateHeight, 100);
    } else {
      // Если фичи скрыты, устанавливаем минимальную высоту
      setContainerHeight(80);
    }
  }, [currentIndex, featuresVisible]);

  const handleChange = (newIndex) => {
    if (newIndex === currentIndex) return;
    
    // Скрываем старые возможности
    setFeaturesVisible(false);
    setFading(true);

    // Меняем скриншот
    setTimeout(() => {
      setCurrentIndex(newIndex);
      setFading(false);
    }, 300);

    // Показываем новые возможности с задержкой
    setTimeout(() => {
      setFeaturesVisible(true);
    }, 400);
  };

  const changeScreenshot = (index) => {
    handleChange(index);
  };

  const nextScreenshot = () => {
    handleChange((currentIndex + 1) % ScreenShotsData.length);
  };

  // Инициализация видимости возможностей при первой загрузке
  useEffect(() => {
    const timer = setTimeout(() => {
      setFeaturesVisible(true);
    }, 800);
    return () => clearTimeout(timer);
  }, []);

  // Автопереключение
  useEffect(() => {
    const interval = setInterval(nextScreenshot, 10000);
    return () => clearInterval(interval);
  }, [currentIndex]);

  // Обработчик клавиатуры
  useEffect(() => {
    const handleKeyDown = (e) => {
      if (e.key === 'ArrowLeft') {
        handleChange((currentIndex - 1 + ScreenShotsData.length) % ScreenShotsData.length);
      }
      if (e.key === 'ArrowRight' || e.key === ' ') {
        e.preventDefault();
        nextScreenshot();
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    return () => document.removeEventListener('keydown', handleKeyDown);
  }, [currentIndex]);

  const currentScreenShots = ScreenShotsData[currentIndex];

  return (
    <section className="ScreenShots-section">
      <div className="container ScreenShots-container">
        <div className="monitor-container">
          <div className="monitor">
            <div 
              className="screen"
              onClick={nextScreenshot}
              onKeyDown={(e) => e.key === 'Enter' && nextScreenshot()}
              tabIndex={0}
            >
              <img 
                src={currentScreenShots.screenshot} 
                alt={currentScreenShots.name}
                className={`screenshot-image ${fading ? 'fading' : ''}`}
                loading="lazy"                    // ← ленивая загрузка
                decoding="async"
              />
              
            </div>
          </div>
        </div>

        <div className="ScreenShots-panel">
          <div className="ScreenShots-row">
            {ScreenShotsData.map((ScreenShots, index) => (
              <div 
                key={ScreenShots.id}
                className={`ScreenShots-card ${currentIndex === index ? 'active' : ''}`}
                onClick={() => changeScreenshot(index)}
              >
                <div className="ScreenShots-content">
                  <div className="ScreenShots-title">
                    <div className="ScreenShots-icon">
                      {ScreenShots.icon}
                    </div>
                    <div className="ScreenShots-name">
                      {ScreenShots.name}
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <div 
          className="features-grid-container"
          style={{ height: `${containerHeight}px` }}
        >
          <div 
            ref={gridRef}
            className={`features-grid ${featuresVisible ? '' : 'hidden'}`}
          >
            {currentScreenShots.features.map((feature, index) => (
              <div 
                key={`${currentScreenShots.id}-${index}`} 
                className={`feature-square ${featuresVisible ? 'visible' : ''}`}
                style={{
                  animationDelay: featuresVisible ? `${index * 0.1}s` : '0s'
                }}
              >
                <div className="feature-square-content">
                  <div className="feature-text">
                    {feature}
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ScreenShots;